/**
 * Enum for column sorting direction.
 * @readonly
 * @enum {string}
 */
const SortDirection = Object.freeze({
    Asc: 'asc',
    Desc: 'desc',
});

export default SortDirection;
